// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login", { replace: true }); return; }
    const session_id = m[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        setUser(data.user);
        window.history.replaceState({}, document.title, "/");
        toast.success(`¡Hola ${data.user.name.split(" ")[0]}!`);
        nav(data.user.role === "admin" ? "/admin" : data.user.role === "professional" ? "/pro" : "/owner", { replace: true });
      } catch (e) {
        toast.error(apiErr(e));
        nav("/login", { replace: true });
      }
    })();
  }, [location, nav, setUser]);

  return <div className="min-h-screen hub-cream flex items-center justify-center"><div className="font-serif text-2xl text-[#0B1D3A]">Iniciando sesión...</div></div>;
}
